import axios from 'axios';

import history from '../utility/common/History.js';

import { updateUserTokenExpiration } from './AuthActions.js';

import {
  REPORT_CLEAR_DATA,
  REPORT_SET_DATA,
  REPORT_APPEND_DATA,
  REPORT_PAD_APPEND_DATA,
  REPORT_PAD_SET_DATA,

  REPORT_FETCH_DATA_FAIL,
  REPORT_SET_INPUT_DATA,
  REPORT_RESET_INPUT_DATA,

  REPORT_UPDATE_DATA,
  REPORT_BUSINESS_CLAIM_INFO_SUCCESS,
  REPORT_BUSINESS_CLAIM_INFO_FAIL,

  REPORT_CLAIM_DETAILS_INFO,
  REPORT_CLAIM_DETAILS_INFO_SUCCESS,
  REPORT_CLAIM_DETAILS_INFO_FAIL,

  REPORT_CLAIM_INFO,
  REPORT_CLAIM_INFO_SUCCESS,
  REPORT_CLAIM_INFO_FAIL,

  REPORT_SUMMARY_INFO,
  REPORT_SUMMARY_INFO_SUCCESS,
  REPORT_SUMMARY_INFO_FAIL,

  REPORT_BALANCE_INFO,
  REPORT_BALANCE_INFO_FAIL,
  REPORT_BALANCE_INFO_SUCCESS,

  SNACKBAR_SET,
  GENERAL_REQUEST_LOADED,
  GENERAL_REQUEST_LOADING

} from './types';
import { HSAFormat } from '../utility/common/GlobalHSA.js';

import { businessReportList } from '../components/clients/myolympia/company/reports/CompanyReportLists';

const { REACT_APP_API_URL } = process.env;

// ******************************************************************** //
// ************ General *********************************************** //
// ******************************************************************** //
export const updateReportField = (fieldGroup, fieldName, fieldValue) => {
  return (dispatch) => {
    dispatch({
      type: REPORT_UPDATE_DATA,
      datagroup: fieldGroup,
      dataname: fieldName,
      datavalue: fieldValue
    })
  };
};

// ******************************************************************** //
// ************ Get Employee Claim Activity Report ******************** //
// ******************************************************************** //

export const getEmployeeClaimActivityReport = (token, userId, options) => {
  return (dispatch) => {
    dispatch({
      type: REPORT_CLAIM_INFO
    });
    const data = {userId: userId, ...options };
    const endpoint = '/employee/claim-report';
    const responseDispatches = {fail: REPORT_CLAIM_INFO_FAIL, success: REPORT_CLAIM_INFO_SUCCESS};
    const responseRedirects = { fail: null, success: null };
    const showSnackBar = { fail: true, success: false };
    getListApi(dispatch, token, endpoint, 'claimReport',data, responseDispatches, responseRedirects, showSnackBar);

  };
}

/* -------------------------------------------------------------- */
export const getEmployeeSummaryOfBenefitsReport = (token, userId, options) => {
  return (dispatch) => {
    dispatch({
      type: REPORT_SUMMARY_INFO
    });
    const data = {userId: userId, ...options };
    const endpoint = '/employee/summary-of-benefits-report/';
    const responseDispatches = {fail: REPORT_SUMMARY_INFO_FAIL, success: REPORT_SUMMARY_INFO_SUCCESS};
    const responseRedirects = { fail: null, success: null };
    const showSnackBar = { fail: true, success: false };
    getListApi(dispatch, token, endpoint, 'summaryReport', data, responseDispatches, responseRedirects, showSnackBar);

  };
}

/* -------------------------------------------------------------- */
export const getEmployeeBalanceReport = (token, userId, options) => {
  return (dispatch) => {
    dispatch({
      type: REPORT_BALANCE_INFO
    });
    const data = {userId: userId, ...options };
    const endpoint = '/employee/balance-report/';
    const responseDispatches = {fail: REPORT_BALANCE_INFO_FAIL, success: REPORT_BALANCE_INFO_SUCCESS};
    const responseRedirects = { fail: null, success: null };
    const showSnackBar = { fail: true, success: false };
    getListApi(dispatch, token, endpoint, 'balanceReport'+options.limit, data, responseDispatches, responseRedirects, showSnackBar);

  };
}

// ******************************************************************** //
// ************ Get Business Claim Activity Report ******************** //
// ******************************************************************** //

const getBusinessClaimReportFail = (dispatch, errors) => {
  dispatch({
    type: SNACKBAR_SET,
    message: errors.message,
    severity: 'notificationBarFailed',
    horizontal: 'center',
    vertical: 'bottom',
  });
  dispatch({
    type: REPORT_BUSINESS_CLAIM_INFO_FAIL,
    errors: errors
  });
  if(errors.FORCE_LOGOUT){
    // dispatch({
    //   type: LOGOUT,
    // });
    history.push('/logout');
  }
};

const getBusinessClaimReportSuccess = (dispatch, claimBusinessReport, claimBusinessReportFlat, claimBusinessReportSummary, startdate, enddate, message) => {
  dispatch({
    type: REPORT_BUSINESS_CLAIM_INFO_SUCCESS,
    startdate,
    enddate,
    claimBusinessReport: claimBusinessReport,
    claimBusinessReportFlat: claimBusinessReportFlat,
    claimBusinessReportSummary: [claimBusinessReportSummary],
    message: message
  });
};

// ******************************************************************** //
// ********************** Get Company  Report ************************* //
// ******************************************************************** //

export const getCompanyReport = (token, userId, reportType, fromDate, toDate) => {

  if(businessReportList[reportType] && businessReportList[reportType].type && businessReportList[reportType].type === "collapse"){
    return (dispatch) => {
      dispatch({
        type: REPORT_UPDATE_DATA,
        datagroup: 'reportInput',
        dataname: 'reportType',
        datavalue: reportType
      });
      getGeneralCollapseReportApi(dispatch, { userId: userId, token: token, fromDate: fromDate, toDate: toDate}, "/company/report/"+reportType, businessReportList[reportType].rowHeaders, businessReportList[reportType].collapseHeaders);
    };
  }else{
    return (dispatch) => {
      dispatch({
        type: REPORT_UPDATE_DATA,
        datagroup: 'reportInput',
        dataname: 'reportType',
        datavalue: reportType
      });
      getGeneralReportApi(dispatch, { userId: userId, token: token, fromDate: fromDate, toDate: toDate}, "/company/report/"+reportType, businessReportList[reportType].rowHeaders);
    }
  }
}
// ******************************************************************** //
// ******************* Get Basic General API  Report ****************** //
// ******************************************************************** //

export const formatCell = (value, format) => {
  return HSAFormat(value, format);
}

export const summarizeCell = (summaryCell, value, collapse, args={}) => {
  if(!collapse) return '';
  switch(collapse){
    case 'none':
      return '';
    case 'sum':
      const amount = parseFloat(String(value).replaceAll(/[,$]/g, ''));
      return (summaryCell)? summaryCell + amount : amount;
    default:
      return '';
  } 
}

export const formatSummaryCell = (value, collapse, format, args={}) => {
  if(!collapse) return '';
  switch(collapse){
    case 'none':
      return '';
    case 'sum':
      return HSAFormat(value, format);
    default:
      return '';
  } 
}

export const collapseCell = (cell, value, collapse, args={}) => {
  if(!value) return cell;
  switch(collapse){
    case 'none':
      return value;
    case 'sum':
      cell = parseFloat(String(cell).replaceAll(/[,$]/g, ''));
      value = parseFloat(String(value).replaceAll(/[,$]/g, ''));
      return (cell)? cell + value : value;
    default:
      return value;
  } 
}


const getGeneralReportApi = (dispatch, args={}, url='', rowHeader=null) => {
  dispatch({
      type: REPORT_CLAIM_INFO
  });
  axios.post( REACT_APP_API_URL + url, args)
  .then((response) => {
    if (response.data.code !== 0 || !rowHeader) {
      getBusinessClaimReportFail(dispatch, response.data.data.error);
      return;
    }
    const reportArray = [];
    var reportSummmaryRow = {SUMMARY_TITLE:'Grand Total'};

    for (var i = 0; i < Object.values(response.data.data.report).length; i++) {
        var tmpObj = {row: i, };

        for (var rhead = 0; rhead < Object.values(rowHeader).length; rhead++) {
          tmpObj[rowHeader[rhead].key] = formatCell(response.data.data.report[i][rowHeader[rhead].key], rowHeader[rhead].format);
          reportSummmaryRow[rowHeader[rhead].key] = summarizeCell(reportSummmaryRow[rowHeader[rhead].key], tmpObj[rowHeader[rhead].key], rowHeader[rhead].collapse); 
        }
        reportArray.push( tmpObj );
    }

    for (var rhead4 = 0; rhead4 < Object.values(rowHeader).length; rhead4++) {
      reportSummmaryRow[rowHeader[rhead4].key] = formatSummaryCell(reportSummmaryRow[rowHeader[rhead4].key], rowHeader[rhead4].collapse, rowHeader[rhead4].format);
    }

    getBusinessClaimReportSuccess(dispatch, reportArray, reportArray, reportSummmaryRow, args.fromDate, args.toDate, response.data.data.message);
  })
  .catch((error) => {
    getBusinessClaimReportFail(dispatch, {message: 'Failed to load report.'});
  });
};

/*--------------------------------------------------------------------*/

const getGeneralCollapseReportApi = (dispatch, args={}, url='', rowHeader=null, collapseHeader=null) => {
  dispatch({
      type: REPORT_CLAIM_INFO
  });
  axios.post( REACT_APP_API_URL + url, args)
  .then((response) => {
    if (response.data.code !== 0 || !rowHeader) {
      getBusinessClaimReportFail(dispatch, response.data.data.error);
      return;
    }
    const reportCollapseArray = [];
    const reportFlatArray = [];
    var reportSummmaryRow = {SUMMARY_TITLE:'Grand Total'};

    for (var reportGrouping of Object.keys(response.data.data.report)) {
      var tmpRowObj = {row: reportGrouping };
      tmpRowObj['collapse'] = [];
      for (var i = 0; i < Object.values(response.data.data.report[reportGrouping]).length; i++) {
          for (var rhead2 = 0; rhead2 < Object.values(rowHeader).length; rhead2++) {
            tmpRowObj[rowHeader[rhead2].key] = collapseCell(tmpRowObj[rowHeader[rhead2].key], response.data.data.report[reportGrouping][i][rowHeader[rhead2].key], rowHeader[rhead2].collapse);
          }

          var tmpObj = {row: i, };

          for (var colhead = 0; colhead < Object.values(collapseHeader).length; colhead++) {
            tmpObj[collapseHeader[colhead].key] = formatCell(response.data.data.report[reportGrouping][i][collapseHeader[colhead].key], collapseHeader[colhead].format);
          }

          tmpRowObj['collapse'].push( tmpObj );
          reportFlatArray.push( tmpObj );
      }

      for (var rhead3 = 0; rhead3 < Object.values(rowHeader).length; rhead3++) {
        tmpRowObj[rowHeader[rhead3].key] = formatCell(tmpRowObj[rowHeader[rhead3].key], rowHeader[rhead3].format);
        reportSummmaryRow[rowHeader[rhead3].key] = summarizeCell(reportSummmaryRow[rowHeader[rhead3].key], tmpRowObj[rowHeader[rhead3].key], rowHeader[rhead3].collapse); 
      }

      reportCollapseArray.push( tmpRowObj );
    }
    for (var rhead4 = 0; rhead4 < Object.values(rowHeader).length; rhead4++) {
      reportSummmaryRow[rowHeader[rhead4].key] = formatSummaryCell(reportSummmaryRow[rowHeader[rhead4].key], rowHeader[rhead4].collapse, rowHeader[rhead4].format);
    }
    getBusinessClaimReportSuccess(dispatch, reportCollapseArray, reportFlatArray, reportSummmaryRow, args.fromDate, args.toDate, response.data.data.message);
  })
  .catch((error) => {
    getBusinessClaimReportFail(dispatch, {message: 'Failed to load report.'});
  });
};

// ******************************************************************** //
// ************ Get Employee Claim Details **************************** //
// ******************************************************************** //


export const getEmployeeClaimDetails = (userId, token, requestedUserId, claimId) => {
  return (dispatch) => {
    getEmployeeClaimDetailsApi(dispatch, userId, token, requestedUserId, claimId);
  };
}

const getEmployeeClaimDetailsApi = (dispatch, userId, token, requestedUserId, claimId) => {
  dispatch({
      type: REPORT_CLAIM_DETAILS_INFO
  });
  axios.post(`${REACT_APP_API_URL}/employee/claim-details`, {
    token,
    userId,
    requestedUserId,
    claimId
  })
  .then((response) => {
    if (response.data.code === 0) {
      updateUserTokenExpiration(dispatch, response.data.data.TOKEN_EXPIRY, response.data.data.SERVER_TIME);
      getEmployeeClaimDetailsSuccess(dispatch, response.data.data.claimDetails, response.data.data.auditFiles, response.data.data.message);
    }else{
      getEmployeeClaimDetailsFail(dispatch, response.data.data.error);
    }
  })
  .catch((error) => {
    getEmployeeClaimDetailsFail(dispatch, {message: 'Failed to load claim details.'});
  });
};

const getEmployeeClaimDetailsFail = (dispatch, errors) => {
  dispatch({
    type: SNACKBAR_SET,
    message: errors.message,
    severity: 'notificationBarFailed',
    horizontal: 'center',
    vertical: 'bottom',
  });
  dispatch({
    type: REPORT_CLAIM_DETAILS_INFO_FAIL,
    errors: errors
  });

  if(errors.FORCE_LOGOUT){
    // dispatch({
    //   type: LOGOUT,
    // });
    history.push('/logout');
  }else {
    history.push('/');
  }
};

const getEmployeeClaimDetailsSuccess = (dispatch, claimDetails, auditFiles, message) => {
  // dispatch({
  //   type: SNACKBAR_SET,
  //   message: message,
  //   severity: 'notificationBarSuccess',
  //   horizontal: 'center',
  //   vertical: 'bottom',
  // });
  dispatch({
    type: REPORT_CLAIM_DETAILS_INFO_SUCCESS,
    claimDetails: claimDetails,
    auditFiles: auditFiles,
    message: message
  });
};


/****************************************************************************************/
/*                                    Agent Reports                                    */
/****************************************************************************************/


/*-------------------------- Tools List Interface for List Manager --------------------*/
export const getReportToolsList = (token, userID, reportDataName, reportState, pageAction, rowCount=0) => {

  return (dispatch) => {
    const data = {toolsUser: userID};
    const endpoint = '/tools/get-audit-pads';
    const responseDispatches = {fail: REPORT_FETCH_DATA_FAIL, success: REPORT_PAD_APPEND_DATA};
    const refreshResponseDispatches = {fail: REPORT_FETCH_DATA_FAIL, success: REPORT_PAD_SET_DATA};
    const responseRedirects = { fail: null, success: null };
    const showSnackBar = { fail: true, success: true };

    getListManager(dispatch, token, reportDataName, rowCount, reportState, pageAction, data, endpoint, responseDispatches, responseRedirects, showSnackBar, refreshResponseDispatches );
  }

}

/*-------------------------- Agent List Interface for List Manager --------------------*/
export const getReportAgentList = (token, userID, reportDataName, reportState, pageAction, rowCount=0) => {

  return (dispatch) => {
    const data = {agentId: userID}
    const endpoint = '/partner/report/agent-list';
    const responseDispatches = { fail: REPORT_FETCH_DATA_FAIL, success: REPORT_APPEND_DATA};
    const responseRedirects = { fail: null, success: null };
    const showSnackBar = { fail: true, success: false };

    getListManager(dispatch, token, reportDataName, rowCount, reportState, pageAction, data, endpoint, responseDispatches, responseRedirects, showSnackBar );
  }

}

/*-------------------------- Client List Interface for List Manager --------------------*/
export const getReportClientList = (token, userID, reportDataName, reportState, pageAction, requestedId, rowCount=0) => {

  return (dispatch) => {
    const data = {agentId: userID, requestedId: requestedId}
    const endpoint = '/partner/report/client-list';
    const responseDispatches = { fail: REPORT_FETCH_DATA_FAIL, success: REPORT_APPEND_DATA};
    const responseRedirects = { fail: null, success: null };
    const showSnackBar = { fail: true, success: false };

    getListManager(dispatch, token, reportDataName, rowCount, reportState, pageAction, data, endpoint, responseDispatches, responseRedirects, showSnackBar );
  }

}

/*-------------------------- Sales List Interface for List Manager --------------------*/
export const getReportSalesList = (token, userID, reportDataName, reportState, pageAction, requestedId, rowCount=0) => {

  return (dispatch) => {
    const data = {agentId: userID, requestedId: requestedId}
    const endpoint = '/partner/report/sales-list';
    const responseDispatches = { fail: REPORT_FETCH_DATA_FAIL, success: REPORT_APPEND_DATA};
    const responseRedirects = { fail: null, success: null };
    const showSnackBar = { fail: true, success: false };

    getListManager(dispatch, token, reportDataName, rowCount, reportState, pageAction, data, endpoint, responseDispatches, responseRedirects, showSnackBar );
  }

}

/*-------------------------- Upcoming Renewals List Interface for List Manager --------------------*/
export const getReportUpcomingRenewalsList = (token, userID, reportDataName, reportState, pageAction, requestedId, rowCount=0) => {

  return (dispatch) => {
    const data = {agentId: userID, requestedId: requestedId}
    const endpoint = '/partner/report/upcoming-renewals-list';
    const responseDispatches = { fail: REPORT_FETCH_DATA_FAIL, success: REPORT_APPEND_DATA};
    const responseRedirects = { fail: null, success: null };
    const showSnackBar = { fail: true, success: false };

    getListManager(dispatch, token, reportDataName, rowCount, reportState, pageAction, data, endpoint, responseDispatches, responseRedirects, showSnackBar );
  }

}

/*-------------------------- Sales List Interface for List Manager --------------------*/
export const getReportCommissionsList = (token, userID, reportDataName, reportState, pageAction, requestedId, rowCount=0) => {

  return (dispatch) => {
    const data = {agentId: userID, requestedId: requestedId}
    const endpoint = '/partner/report/commissions-list';
    const responseDispatches = { fail: REPORT_FETCH_DATA_FAIL, success: REPORT_APPEND_DATA};
    const responseRedirects = { fail: null, success: null };
    const showSnackBar = { fail: true, success: false };

    getListManager(dispatch, token, reportDataName, rowCount, reportState, pageAction, data, endpoint, responseDispatches, responseRedirects, showSnackBar );
  }

}

/****************************************************************************************/
/*           Company Reports (NOT IN USE but will use to reduce fetch size)             */
/****************************************************************************************/

export const getCompanyReportList = (token, erId, userId, reportDataName, reportState, pageAction, rowCount=0) => {
  return (dispatch) => {
    const data = {erId: erId, userId: userId }
    const endpoint = '/company/report/'+reportDataName;
    const responseDispatches = { fail: REPORT_FETCH_DATA_FAIL, success: REPORT_APPEND_DATA};
    const responseRedirects = { fail: null, success: null };
    const showSnackBar = { fail: true, success: false };

    getListManager(dispatch, token, reportDataName, rowCount, reportState, pageAction, data, endpoint, responseDispatches, responseRedirects, showSnackBar );
  }
}

/****************************************************************************************/
/*                                 Report List Manager                                  */
/****************************************************************************************/

export const getListManager = (dispatch, token, reportDataName, rowCount, reportState, pageAction, data, endpoint, responseDispatches, responseRedirects, showSnackBar, refreshResponseDispatches={ fail: REPORT_FETCH_DATA_FAIL, success: REPORT_SET_DATA}, loadAll=true) => {
  switch(pageAction){
    case 'next':
      if(reportState.endOfList === true){
        dispatch({
          type: SNACKBAR_SET,
          message: 'End of List',
          severity: 'notificationBarFailed',
          horizontal: 'center',
          vertical: 'bottom',
        });
      }
      else if((reportState.pageNumber + 1) * reportState.pageLength >= rowCount && rowCount % reportState.pageLength === 0){
        if(!loadAll){
          dispatch({ type: GENERAL_REQUEST_LOADING });
          const combinedData = {...data, ...reportState, recordStart: (reportState.fetchPage + 1) * reportState.fetchLength, recordEnd: ((reportState.fetchPage + 1) * reportState.fetchLength) + reportState.fetchLength}
          getListApi(dispatch, token, endpoint, reportDataName, combinedData, responseDispatches, responseRedirects, showSnackBar, false);
        }

        dispatch({ type: REPORT_SET_INPUT_DATA, reportName: reportDataName, reportInput: {...reportState, pageNumber: reportState.pageNumber + 1, fetchPage: reportState.fetchPage + 1} });
      }
      else {
        dispatch({ type: REPORT_SET_INPUT_DATA, reportName: reportDataName, reportInput: {...reportState, pageNumber: reportState.pageNumber + 1} });
      }
      break;
    case 'prev':
      if(reportState.pageNumber >= 1){
        dispatch({ type: REPORT_SET_INPUT_DATA, reportName: reportDataName, reportInput: {...reportState, pageNumber: reportState.pageNumber - 1} });
      }
      else{
        dispatch({
          type: SNACKBAR_SET,
          message: 'Beginning of List',
          severity: 'notificationBarFailed',
          horizontal: 'center',
          vertical: 'bottom',
        });
      }
      break;
    default:
      dispatch({ type: GENERAL_REQUEST_LOADING });
      dispatch({ type: REPORT_CLEAR_DATA });
      dispatch({ type: REPORT_RESET_INPUT_DATA, reportName: reportDataName});
      dispatch({ type: REPORT_SET_INPUT_DATA, reportName: reportDataName, reportInput: {...reportState, pageNumber: 1} });
      const combinedData = {...data, ...reportState, recordStart: (reportState.fetchPage) * reportState.fetchLength, recordEnd: ((reportState.fetchPage) * reportState.fetchLength) + reportState.fetchLength}
      getListApi(dispatch, token, endpoint, reportDataName, combinedData, refreshResponseDispatches, responseRedirects, showSnackBar, true);
      break;
  }
}
/****************************************************************************************/
/*                                   Report List API                                    */
/****************************************************************************************/
const getListApi = (dispatch, token, endpoint, reportName, dataObj, responseDispatches, responseRedirects, showSnackBar, clearGeneralLoading=false) => {

  axios.post(REACT_APP_API_URL + endpoint, {
    data: dataObj,
  }, { headers: { token: token } })
  .then((response) => {
    if (response.data.code === 0) {
      updateUserTokenExpiration(dispatch, response.data.data.TOKEN_EXPIRY, response.data.data.SERVER_TIME);
      listSuccess(
        dispatch,
        reportName,
        response.data.data,
        response.data.data.message,
        responseDispatches.success,
        responseRedirects.success,
        showSnackBar.success,
        clearGeneralLoading
      );
    } else {
      listFail(
        dispatch,
        reportName,
        true,
        response.data.data.error,
        responseDispatches.fail,
        responseRedirects.fail,
        showSnackBar.fail,
        clearGeneralLoading
      );
    }
  })
  .catch((error) => {
    listFail(
      dispatch,
      reportName,
      true,
      error,
      responseDispatches.fail,
      responseRedirects.fail,
      showSnackBar.fail,
      true
    );
  });

};

const listSuccess = (
  dispatch,
  reportName,
  data,
  message,
  responseDispatch,
  responseRedirect,
  showSnackBar,
  clearGeneralLoading
) => {
  dispatch({
    type: responseDispatch,
    reportName: reportName,
    data,
  });
  dispatch({type: GENERAL_REQUEST_LOADED})
  if(showSnackBar === true){
    dispatch({
      type: SNACKBAR_SET,
      message: message,
      severity: 'notificationBarSuccess',
      horizontal: 'center',
      vertical: 'bottom',
    });
  }
  if(responseRedirect) history.push(responseRedirect);
};

const listFail = (
  dispatch,
  reportName,
  error,
  errors,
  responseDispatch,
  responseRedirect,
  showSnackBar,
  clearGeneralLoading
) => {
  dispatch({
    type: responseDispatch,
    reportName: reportName,
    error,
    errors
  });
  dispatch({type: GENERAL_REQUEST_LOADED})
  if(showSnackBar === true){
    dispatch({
      type: SNACKBAR_SET,
      message: (errors.GENERAL)? errors.GENERAL: errors.message,
      severity: 'notificationBarFailed',
      horizontal: 'center',
      vertical: 'bottom',
    });
  }
  if(errors.FORCE_LOGOUT){
    history.push('/logout');
  } else {
    if(responseRedirect) history.push(responseRedirect);
  }

};
